module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABxSURBVHgB7dXRDYAwCEVRcALdwM2cwRGctG5gN8AygLaxSWuTexLCDwnw9UQAAADwyMy2VJe1F3x37j4teCCktkofUVWXt4FJ8mbpJ+YGSh7YU53Snh9/CACMjSSuQxI7khgAviOJ65DEjiQGAAD4qRtuwpSVxu98KwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pui-icons-v-0-1/icn-hamburger-white.png
// module id = RMmP
// module chunks = 0